// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"26":"b441086c","40":"c6457241","165":"ef494304","256":"851b1c16","294":"3ade5905","370":"19a8aa04","387":"27c3389e","501":"2d020c3c","587":"7ccff614","604":"3c552358","613":"136bf2c0","694":"7a987c94","926":"ddc99ec5"}[chunkId] + ".chunk.js";
};